import { BRAND, isMarketGB } from '../../constants/main';
import { HeaderStyledAC } from './AC/HeaderStyled.AC';
import { HeaderStyledAP } from './AP/HeaderStyled.AP';
import { HeaderStyledDS } from './DS/HeaderStyled.DS';
import { HeaderStyledOV } from './OV/HeaderStyled.OV';
import { HeaderStyledOV as HeaderStyledOV_GB } from './OV/GB/HeaderStyled.OV';
import { SC } from '../../styles/theme';
import { FC } from 'react';
import { IHeaderItem } from '../../redux/content/content.duck.interface';
import { TBudgetType } from '../../services/core/sdk/constants/sdkFields';

export interface HeaderProps extends SC {
    title: string | JSX.Element;
    subtitle?: string | JSX.Element;
    paymentJourney?: TBudgetType;
    links?: IHeaderItem[];
}

const Header: FC<HeaderProps> = props => {
    switch (BRAND) {
        case 'AC':
            return <HeaderStyledAC {...props} />;
        case 'AP':
            return <HeaderStyledAP {...props} />;
        case 'DS':
            return <HeaderStyledDS {...props} />;
        case 'OV':
            return isMarketGB ? <HeaderStyledOV_GB {...props} /> : <HeaderStyledOV {...props} />;
        default:
            return null;
    }
};

export default Header;
